import { CreateUsersForm } from "@/components/settings/CreateUsersForm";

const CreatePatient = () => {
  return (
    <div className="flex h-full overflow-hidden p-2 sm:p-3">
      <div className="flex-1 min-h-0 min-w-0 overflow-y-auto">
        <div className="mx-auto w-full max-w-4xl px-2 sm:px-4">
          <CreateUsersForm />
        </div>
      </div>
    </div>
  );
};

export default CreatePatient;
